import type { MetricAccent } from '@/common-components/MetricCard';

/** Category slugs come from the server; these are the display labels and icons. */
export const CATEGORY_META: Record<string, { label: string; icon: string; accent: MetricAccent }> = {
  electronics: { label: 'Electronics & Gadgets', icon: '📷', accent: 'brand' },
  study: { label: 'Books & Study Materials', icon: '📚', accent: 'info' },
  entertainment: { label: 'Entertainment', icon: '🎵', accent: 'success' },
  other: { label: 'Other', icon: '🏕️', accent: 'pink' },
};

/** Steps of the onboarding funnel, in order, with the copy the panel shows for each. */
export const FUNNEL_STEPS = [
  { key: 'verified', label: '✅ Verified their college email', hint: 'Everyone who ever passed OTP' },
  { key: 'completedProfile', label: '📝 Finished profile setup', hint: 'Became a real account' },
  { key: 'posted', label: '📣 Posted a listing or shoutt', hint: 'Contributed something' },
  { key: 'booked', label: '📦 Booked a rental', hint: 'Completed the loop' },
] as const;
